var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "active", class: _vm.currentStepClass },
    [
      _c(
        "keep-alive",
        [
          _c(_vm.currentStepComponent, {
            tag: "component",
            attrs: {
              step: _vm.step,
              user: _vm.user,
              useIdCard: _vm.useIdCard,
              companyName: _vm.companyName,
              "step-navigation": _vm.stepNavigation,
            },
            on: {
              "show-buttons": _vm.showButtons,
              "current-step3-changed": _vm.currentStep3Changed,
              validated: _vm.stepValidated,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowButtons
        ? _c("div", { staticClass: "btn-box step" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-line-dark btn-lg icon icon-arrow_prev left",
                  attrs: { type: "button", disabled: _vm.step === 1 },
                  on: { click: _vm.onPreviousStep },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("preRegistration.common.previousStep")) +
                      "\n      "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col ml-auto" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-line-dark btn-lg icon icon-arrow_next",
                  attrs: { type: "button", disabled: !_vm.validated },
                  on: { click: _vm.onNextStep },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("preRegistration.common.nextStep")) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }